<template>
<div>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div class="d-flex justify-space-between align-center" v-if="loading_page === false">
        <div class="d-flex align-center">
            <v-btn icon class="ma-2" @click="prev()">
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn icon class="ma-2" @click="next()">
                <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
            <h2>
                {{ title_month }}
            </h2>
        </div>
        <div>
            <v-btn text :color="shift_id == shift_detail.id ? 'primary' : ''" @click="page(shift_detail.id)" v-for="(shift_detail,index) in shift_list" :key="index" class="font_shift_list_work_schedule_list">{{ shift_detail.shift_name }}</v-btn>
        </div>
    </div>
    <v-sheet height="1500" v-show="loading_page === false">
        <v-calendar ref="calendar" v-model="value" :events="events" locale="th" @change="workScheduleList"></v-calendar>
    </v-sheet>
</div>
</template>

<script>
import workschedule from '@/api/team/teamworkschedule/workschedule.js'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data: () => ({
        tab_active: null,
        loading_page: true,
        title_month: '',
        value: '',
        shift_list: [],
        shift_id: null,
        events: [],
    }),
    methods: {
        async prev() {
            this.loading_page = true
            await this.$refs.calendar.prev()
            let title_month_calendar = this.$refs.calendar.title.split(" ")
            let title_month_list = this.$store.state.monthList.find((detail) => {
                return detail.name_en == title_month_calendar[0] || detail.name == title_month_calendar[0]
            })
            let year = parseInt(title_month_calendar[1]) + 543
            this.title_month = title_month_list.name + " " + year
        },
        async next() {
            this.loading_page = true
            await this.$refs.calendar.next()
            let title_month_calendar = this.$refs.calendar.title.split(" ")
            let title_month_list = this.$store.state.monthList.find((detail) => {
                return detail.name_en == title_month_calendar[0] || detail.name == title_month_calendar[0]
            })
            let year = parseInt(title_month_calendar[1]) + 543
            this.title_month = title_month_list.name + " " + year
        },
        async shiftList() {
            workschedule.shiftList().then((response) => {
                if (response.data.successful === true) {
                    this.shift_list = response.data.shiftDEtail
                }

            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async page(id) {
            this.loading_page = true
            this.shift_id = id
            this.events = []
            await workschedule.workScheduleList(this.shift_id).then((response) => {
                if (response.data.successful === true) {
                    response.data.work.forEach(detail => {
                        if (detail.weeklyHoliday == true) {
                            this.events.push({
                                name: 'วันหยุดประจำสัปดาห์',
                                start: detail.date,
                                color: 'warning',
                            })
                        }
                        if (detail.special_holidays == true) {
                            this.events.push({
                                name: 'วันหยุดพิเศษ',
                                start: detail.date,
                                color: 'error',
                            })
                        }
                        if (detail.employee.length > 0) {
                            detail.employee.forEach(detail_employee => {
                                if (detail_employee.employee_holiday == false) {
                                    this.events.push({
                                        name: detail_employee.employee_name,
                                        start: detail.date,
                                        color: 'success',
                                    })
                                }
                            })
                        }
                    })
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
            this.loading_page = false
        },
        async workScheduleList() {
            this.events = []
            if (this.shift_id === null) {
                await workschedule.shiftList().then((response) => {
                    if (response.data.successful === true) {
                        this.shift_list = response.data.shiftDEtail
                        this.shift_id = response.data.shiftDEtail[0].id
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
            }
            await workschedule.workScheduleList(this.shift_id).then((response) => {
                if (response.data.successful === true) {
                    response.data.work.forEach(detail => {
                        if (detail.weeklyHoliday == true) {
                            this.events.push({
                                name: 'วันหยุดประจำสัปดาห์',
                                start: detail.date,
                                color: 'warning',
                            })
                        }
                        if (detail.special_holidays == true) {
                            this.events.push({
                                name: 'วันหยุดพิเศษ',
                                start: detail.date,
                                color: 'error',
                            })
                        }
                        if (detail.employee.length > 0) {
                            detail.employee.forEach(detail_employee => {
                                if (detail_employee.employee_holiday == false) {
                                    this.events.push({
                                        name: detail_employee.employee_name,
                                        start: detail.date,
                                        color: 'success',
                                    })
                                }
                            })
                        }
                    })
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
            this.loading_page = false
        },
    },
    mounted() {
        let title_month_calendar = this.$refs.calendar.title.split(" ")
        let title_month_list = this.$store.state.monthList.find((detail) => {
            return detail.name_en == title_month_calendar[0] || detail.name == title_month_calendar[0]
        })
        let year = parseInt(title_month_calendar[1]) + 543
        this.title_month = title_month_list.name + " " + year
        this.shiftList()
    },
}
</script>

<style scoped>
.font_shift_list_work_schedule_list {
    font-size: 17px;
}
</style>
